<script setup lang="ts" generic="Value">
import { toRef } from 'vue';
import { EnumerationValueDto } from '@/api/generator';
import EnumerationValue from '@/components/forms/dataTypes/EnumerationValue.vue';
import { VeeEnumerationValueProps } from '@/components/forms/types.ts';
import { useField, useFieldError } from 'vee-validate';
import { useVeeFormProps } from '../utils';

type VeeEnumerationValueEmits = {
  'update:enumerationValue': [value: EnumerationValueDto | undefined];
  blur: [event: FocusEvent];
};

const props = defineProps<VeeEnumerationValueProps<Value>>();
const emits = defineEmits<VeeEnumerationValueEmits>();

const veeProps = useVeeFormProps(props);

const { value, handleChange, meta, handleBlur, errorMessage } = useField<EnumerationValueDto>(
  toRef(() => props.name),
  undefined,
  {
    validateOnValueUpdate: true,
  },
);

function onUpdate(input: EnumerationValueDto | undefined) {
  handleChange(input, meta.touched);
  emits('update:enumerationValue', input);
}

function onBlur(event: FocusEvent) {
  handleBlur(event);
  emits('blur', event);
}
const valueErrorValue = useFieldError(toRef(() => `${props.name}.value`));
const valueErrorId = useFieldError(toRef(() => `${props.name}.value.id`));
</script>

<template>
  <EnumerationValue
    v-bind="veeProps"
    :errorMessage="errorMessage || valueErrorId || valueErrorValue"
    :enumerationValue="value"
    @update:enumerationValue="onUpdate"
    @blur="onBlur"
  />
</template>
